
function GetBrowserData(){

    /** figure browser type using UserAgent.
     * exposes 
     * @property { Boolean } isChrome
     * @property { Boolean } isSafari
     *  
     */
    function checkBrowser(){

        if( !(typeof(navigator) === 'object' && ( 'userAgent' in navigator ) ) ) return {};

        const userAgent=navigator.userAgent.toLowerCase();

        const isChrome=userAgent.includes('chrome');

        const isSafari=!isChrome && userAgent.includes('safari');


        return {isChrome,isSafari};
    }

    /**
     * list of package extension and respective types.
     */
    const nativeSupports=[
        {
            extension: 'mp4',
            type: 'video/mp4'
        },
        {
            extension: 'm3u8',
            type: 'application/vnd.apple.mpegurl'
        }
    ]

    /**
     * Check for native Video Element support.
     * @param { Instance of HTMLVideoElement } videoTag 
     * @param { String } extension 
     * 
     * @returns { Boolean } if extension is supported.
     */

    function canPlay( videoTag, extension ){
        if( !( videoTag instanceof HTMLVideoElement ) )return false;

        return nativeSupports.some( ( pkg ) => ( 
        ( pkg.extension === extension ) && ( videoTag.canPlayType( pkg.type ) )
        ) )
        
    }

    const instance = {
        checkBrowser,
        canPlay
    }

    return instance;
}

const browserData = GetBrowserData();


export default browserData;



